import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryDepartureSelectorData =
  Content.Components['DepartureSelectorModuleDto'];

interface UseQueryDepartureSelectorOptions {
  enabled?: boolean;
  initialData?: UseQueryDepartureSelectorData;
  parameters?: Content.Components['IPredefinedSearchHeadlessParameters'] & {
    id: string;
    pageId: string;
    predefinedSearchId: number;
  };
}

const useQueryDepartureSelector = ({
  enabled = true,
  initialData,
  parameters,
}: UseQueryDepartureSelectorOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQueryDepartureSelectorData>(
    [QueryId.DEPARTURE_SELECTOR, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/departure-selector';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryDepartureSelector', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryDepartureSelector;
